import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const DatasetNotificationCreateToast = ({ name }) => (
  <PositiveToast className="aridhia-dataset-notification-create-toast">
    <FormattedMessage id="toast.notified" values={{ name }} />
  </PositiveToast>
);

export default DatasetNotificationCreateToast;
